export function abbreviateId(id: string) {
  return id.substring(0, 4);
}
